module.exports = __webpack_public_path__ + "static/media/tavern.e50522f0.glb";